// Modules
import React from "react";
import moment from "moment";
// @ts-ignore
import { LocalizationContext } from "react-localize";

// Styles
import "./CheckAvailabilityResultItem.sass";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

// Services
import { handle401Error } from "Services/service.utils";
import ReservationService from "Services/reservation.service";

// Interfaces
import ResortResult from "Interfaces/ResortResultInterface";
import FormData from "Interfaces/FormDataInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";
import Results from "Interfaces/ResultsInterface";
import Point from "Interfaces/PointInterface";
import { Tip } from "Interfaces/TipInterface";
import { HoldRequestData } from "Interfaces/HoldRequestData";
import { WaitlistData, checkInDay } from "Interfaces/WaitlistData";
import ContractType from "Interfaces/AdvanceSearchInterface";
import { EnhancedSegment, Segment } from "Interfaces/Segment";
import Criteria from "Interfaces/CriteriaInterface";

// Components
import MvIcon from "Generic/MvIcon";
import MvToggle from "Generic/MvToggle";
import DatePicker from "Generic/DatePicker";
import VillasAvailable from "./CheckAvailabilityVillasAvailable";
import VillasNotAvailable from "./CheckAvailabilityVillasNotAvailable";
import PointsForSearch from "./PointsForSearch";
import CheckAvailabilityHotelInformation from "./CheckAvailabilityHotelInformation";
import ConfirmAvailability from "./ConfirmAvailability";
import FilterResults from "Components/PWAS/Components/SearchResults/FilterResults";
import MvModal, { MvResortModal } from "Generic/MvModal";
import ResortInfo from "../SearchResults/ResortInfo/ResortInfo";
import MvDatePicker from "Generic/MvDatePicker";
import MvButtonToggle from "Generic/MvButtonToggle";

// Constants
import { ALERT_MODAL_TYPES } from "Constants";

// Other
import log from "cfg";
import { getUniqueContractSegments } from "Utils/Search";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";

type Owner = {
  point: number;
};

const defaultCheckInDays: checkInDay[] = [
  { weekName: "Sun", selected: true },
  { weekName: "Mon", selected: true },
  { weekName: "Tue", selected: true },
  { weekName: "Wed", selected: true },
  { weekName: "Thu", selected: true },
  { weekName: "Fri", selected: true },
  { weekName: "Sat", selected: true },
];

type ResultItemState = {
  dateForPoints: Date | null;
  selectedDate: Date | null;
  hideCalendar: boolean;
  buttonClicked: boolean;
  hideHeader: boolean;
  loadError: boolean;
  errorMessage: string;
  errorCode: string;
  monthlyAvailabilityData: Results;
  resortModal: {
    show: boolean;
    propertyCode: string;
  };
  propCode: string;
  loader: boolean;
  // waitlistOptionsForVillasNotAvailable: boolean,
  filters: {
    roomType: string[];
    views: string[];
    activities: string[];
    area: string[];
  };
  // New Type from 1C Code
  resortWaitlistEligible: boolean;
  owner: Owner;
  minWaitlistRoomtypePoint: number;
  startDate: Date | string;
  endDate: Date | string;
  startDateError: boolean;
  endDateError: boolean;
  checkInDays: checkInDay[];
  currentPointsBalance: number;
  potentialPointBalance: number;
  // End new Type from 1C Code
};

type Props = {
  result: ResortResult;
  form: FormData;
  hideAvailability(date?: any): void;
  searchMonths: any[];
  toggleFilterGroup(name: string, boolean?: boolean): void;
  selectedFilters: SelectedFilters;
  onFilterSelect(name: string, item: any): void;
  deleteHeldResorts(): Promise<any>;
  clearFilters(): void;
  getHeldResorts(displayHeldResorts?: boolean): void;
  placeHold(holdRequestData: HoldRequestData): Promise<any>;
  createWaitlist(waitlistData: WaitlistData): Promise<any>;
  goToAYP(resId: number): void;
  toggleAlertModal(type?: string): void;
  accessibilityOptions: any[];
  waitlistToggleChecked: boolean;
  onClearSearch(): void;
  contracts: ContractType[];
  onMonthSelect(date: any): void;
  selectedMonth: any;
  // 1C code new props
  goToWaitlistAYP(waitlistId?: number): void;
  setEditingSegment(segment: EnhancedSegment): void;
  editingSegment: EnhancedSegment | null;
  criteria: Criteria;
  searchForm: FormData;
  sessionId: any;
  apiTimeout: string;
  isAlternateSearchAvailable: boolean;
  toggleMobileFilter?: () => void;
  isMobileFilterOpen: boolean;
};

const InitResults: Results = {
  maxOutMonth: null,
  filters: {
    roomType: [],
    views: [],
    activities: [],
    area: [],
  },
  results: [],
  monthlyresults: [],
  dailyresults: [],
  waitlistresults: [],
  monthlyUnavailable: [], // Check which month is unavailable from 1C code
  disableVoaBookCapability: false, //MVC-228 flag to disable action buttons - continue, hold & browse, waitlist add, back end is giving this
};

const bookingWindow = {
  start: new Date("2018-1-1"),
  end: new Date("2021-12-15"),
};

function sameDay(d1: Date, d2: Date) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

class CheckAvailabilityResultItem extends React.Component<
  Props,
  ResultItemState
> {
  reservationService: ReservationService;

  constructor(props: Props) {
    super(props);

    console.log(`CheckAvailabilityResultItem:`, { props: this.props });

    this.availabilityDateSelect = this.availabilityDateSelect.bind(this);
    this.hideAvailability = this.hideAvailability.bind(this);
    this.getFirstAvailableDate = this.getFirstAvailableDate.bind(this);
    this.handleSpacebar = this.handleSpacebar.bind(this);
    this.fetchMonthlyAvailabilityData =
      this.fetchMonthlyAvailabilityData.bind(this);
    this.reservationService = new ReservationService();
    this.changePropCode = this.changePropCode.bind(this);
    this.onFilteredSelect = this.onFilteredSelect.bind(this);
    this.onFilterClear = this.onFilterClear.bind(this);
    this.isDateOutsideWindow = this.isDateOutsideWindow.bind(this);
    this.getLastDate = this.getLastDate.bind(this);
    this.onCheckInDaySelected = this.onCheckInDaySelected.bind(this);
    // this.handleWaitlistOptionsForVillasNotAvailable = this.handleWaitlistOptionsForVillasNotAvailable.bind(this);
    this.handleInput = this.handleInput.bind(this);

    this.state = {
      dateForPoints: null,
      selectedDate: null,
      hideCalendar: false,
      buttonClicked: false,
      hideHeader: false,
      loadError: false,
      errorMessage: "",
      errorCode: "",
      monthlyAvailabilityData: Object.assign({}, InitResults),
      resortModal: {
        show: false,
        propertyCode: "",
      },
      propCode: "",
      loader: true,
      // waitlistOptionsForVillasNotAvailable: this.props.waitlistToggleChecked,
      filters: {
        roomType: [...this.props.selectedFilters["roomType"].filters],
        views: [...this.props.selectedFilters["views"].filters],
        activities: [],
        area: [],
      },
      resortWaitlistEligible: true,
      owner: {
        point: 1000,
      },
      minWaitlistRoomtypePoint: 850,
      checkInDays: JSON.parse(JSON.stringify(defaultCheckInDays)),
      startDate: moment(this.props.form.startDate).format("MM/DD/YYYY"),
      endDate: moment(this.props.form.startDate)
        .endOf("month")
        .format("MM/DD/YYYY"),
      startDateError: false,
      endDateError: false,
      currentPointsBalance: 0,
      potentialPointBalance: 0,
    };
  }

  // handleWaitlistOptionsForVillasNotAvailable(e: any): void {

  //     this.setState({
  //         waitlistOptionsForVillasNotAvailable: e.target.checked
  //     })

  // }

  componentDidMount() {
    const { localize } = this.context;
    // If room-type filters are selected, and the room type filter group
    // is collapsed, expand the filter group
    if (this.props.selectedFilters["roomType"].filters.length > 0) {
      this.props.toggleFilterGroup("roomType", true);
    }
    this.fetchMonthlyAvailabilityData(this.props.selectedMonth);

    if (this.props.form.flexibleSearch) {
      const lastDate: Date = this.getLastDate(this.props.form.startDate);
      this.setState({
        dateForPoints:
          lastDate > bookingWindow.end ? lastDate : bookingWindow.end,
      });
    } else {
      this.setState({
        dateForPoints: new Date(this.props.form.startDate),
      });
    }
  }

  componentDidUpdate(prevProps: Props, prevState: ResultItemState) {
    // if (prevState.dateForPoints !== this.state.dateForPoints && this.state.dateForPoints) {
    //     let form = { ...this.props.form };
    //     form.flexibleSearch = true;
    //     form.startDate = this.state.dateForPoints.toDateString();
    //     const segments = getUniqueContractSegments(form);

    //     this.reservationService.search(this.props.form, segments).then((result: Results) => {
    //         //result = availableResorts;
    //         const points = result.points || [];
    //         const {
    //             pointsBalance = 0, potentialPointBalance = 0,

    //         } = points.length && points.filter((point: Point) => sameDay(new Date(point.date), this.state.dateForPoints as Date))[0] || {};
    //         this.setState({
    //             currentPointsBalance: pointsBalance,
    //             potentialPointBalance: potentialPointBalance,
    //         })
    //     })
    // }

    if (
      prevProps.editingSegment !== this.props.editingSegment &&
      this.props.editingSegment
    ) {
      const { editingSegment } = this.props;
      this.setState({
        startDate: editingSegment.startDate,
        endDate: editingSegment.endDate,
        checkInDays: editingSegment.checkInDays,
        selectedDate: editingSegment.selectedDate,
        // waitlistOptionsForVillasNotAvailable: true,
      });
    }
  }

  getUpdatedFormData(
    date?: any,
    roomType: string[] = this.state.filters.roomType,
    viewCode: string[] = this.state.filters.views
  ) {
    this.setState({ loader: true });
    let updatedForm = this.props.form;
    updatedForm["centralRoomTypeCode"] = roomType;
    updatedForm["viewCode"] = viewCode;
  
    // Always use EST "today"
    const todayEST = moment.tz("America/New_York");
    const todayStr = todayEST.format("MM/DD/YYYY");
  
    // Normalize incoming date → always string
    let selectedDate = date
      ? moment(date).format("MM/DD/YYYY")
      : moment(this.getStartDate()).format("MM/DD/YYYY");
  
    // Parse ONLY where needed (EST safe)
    const today = moment.tz(todayStr, "MM/DD/YYYY", "America/New_York");
    const selected = moment.tz(selectedDate, "MM/DD/YYYY", "America/New_York");
  
    if (this.props.form.flexibleSearch) {
      // If same month/year → use today, else start of month
      if (today.isSame(selected, "month") && today.isSame(selected, "year")) {
        selectedDate = todayStr;
      } else {
        selectedDate = selected.startOf("month").format("MM/DD/YYYY");
      }
    } else {
      const exactStr = this.props.form.startDate;
      const exact = moment.tz(exactStr, "MM/DD/YYYY", "America/New_York");
  
      if (
        (exact.isSame(selected, "month") && exact.isSame(selected, "year")) ||
        selected.isBefore(exact)
      ) {
        selectedDate = exact.format("MM/DD/YYYY");
      } else {
        selectedDate = selected.startOf("month").format("MM/DD/YYYY");
      }
    }
    console.log("==> updated startDate:", selectedDate);
    return { ...updatedForm, startDate: selectedDate };
  }

  getLastDate(date: string): Date {
    const firstDate = new Date(date);
    return new Date(firstDate.getFullYear(), firstDate.getMonth() + 1, 0);
  }

  refreshMonthlyAvailabilityData(results: Results) {
    const exactSearchDate = moment(this.props.form.startDate).format(
      "MM/DD/YYYY"
    );
    let state: ResultItemState = this.state;
    state.monthlyAvailabilityData = results;
    state.monthlyAvailabilityData.monthlyresults.map(
      (dates) => (dates.date = moment(dates.date).toDate())
    );
    if (!this.props.form.flexibleSearch && !state.selectedDate) {
      const startDate = moment(exactSearchDate).toDate();
      state.selectedDate = startDate;
    }
    state.loader = false;
    state.loadError = false;
    // state.waitlistOptionsForVillasNotAvailable = results.monthlyresults.length === 0 ? true : this.props.waitlistToggleChecked
    // if(results.monthlyUnavailable.length > 0) {
    //     state.minWaitlistRoomtypePoint = results.monthlyUnavailable.reduce((min, unavailable) =>
    //         unavailable.pointsAmount < min ? unavailable.pointsAmount : min, results.monthlyUnavailable[0].pointsAmount
    //     );
    // }

    let datesArray: (string | Date)[] =
      this.state.monthlyAvailabilityData.monthlyresults.map(
        (date) => date.date
      );
    this.setState(state);
  }

  handleErrorMonthlyAvailability(error: any) {
    const { localize } = this.context;
    // const errMsg = error.message ? `${error.message}` : "Unspecified error";
    const errMsg = error.message
      ? `${error.message}`
      : localize("static.content.pwas-search-fatal-error-message");
    if (!handle401Error(error) || error.code == 400) {
      this.setState({
        loader: false,
        loadError: true,
        errorMessage: errMsg,
        errorCode: error.errorCode,
      });
      log.error(`Error: ${JSON.stringify(error)}`);
    }
  }

  fetchMonthlyAvailabilityData(
    date?: any,
    filteredSearch?: boolean,
    formData?: FormData
  ) {
    //this is called from calender date picker when month is selected. need to set this month in state to use in filter changes
    this.props.onMonthSelect(date);

    /**
     * PWAS Analytics on Monthly Availability
     */

    // logAnalyticData({ event: 'Select Availability', siteSection: 'Points Reservation', pageName:'Book My Holiday', website:'' }, {
    //     step:'Step 3:Select Availability',
    //     errorMessagfe:"",
    //     notificationType: "",
    //     errorMessage:"",
    //     resortID:"",
    //     typeofSearch:"",
    //     customerID:"",
    //     filtersApplied: "" // TODO: Populate the data
    // })
    //   trackAnalyticData('points:step3');

    const lastDate: Date = this.getLastDate(date);

    const updatedForm = formData ? formData : this.getUpdatedFormData(date);
    const exactSearchDate = moment(this.props.form.startDate).format(
      "MM/DD/YYYY"
    );
    const segments = getUniqueContractSegments(updatedForm);
    this.setState({
      dateForPoints:
        lastDate > bookingWindow.end ? bookingWindow.end : lastDate,
    });
    this.reservationService
      .searchMonthlyAvailability(
        this.props.result.propertyCode,
        updatedForm,
        exactSearchDate,
        segments
      )
      .then((results: Results) => {
        if (results.errorCode) {
          return Promise.reject(results);
        }
        if (filteredSearch && results.monthlyresults.length === 0) {
          this.props.toggleAlertModal(
            ALERT_MODAL_TYPES.NO_AVAILABILITY_FILTERED_MONTHLY
          );
        }
        this.refreshMonthlyAvailabilityData(results);
      })
      .catch((error: any) => {
        this.handleErrorMonthlyAvailability(error);
      });
  }

  //clear filter selections and refetch data
  onFilterClear() {
    this.props.clearFilters();
    this.setState({
      filters: {
        ...this.state.filters,
        roomType: [],
        views: [],
      },
    });
    const startDate = this.getStartDate();
    const formData = this.getUpdatedFormData(startDate, [], []);
    this.fetchMonthlyAvailabilityData(startDate, false, formData);
  }

  //on filter selections pass in array of filters to fetch

  onFilteredSelect(name: string, value: string) {
    this.props.onFilterSelect(name, value);

    const currentFilters = { ...this.state.filters };

    if (name === "roomType" || name === "views") {
      if (currentFilters[name].includes(value)) {
        let findVal = currentFilters[name].indexOf(value);
        currentFilters[name].splice(findVal, 1);
      } else {
        currentFilters[name].push(value);
      }
    }

    this.setState({
      filters: currentFilters,
    });

    const filteredSearch =
      currentFilters["roomType"].length > 0 ||
      currentFilters["views"].length > 0;
    const startDate = this.getStartDate();
    const formData = this.getUpdatedFormData(
      startDate,
      currentFilters["roomType"],
      currentFilters["views"]
    );
    this.fetchMonthlyAvailabilityData(startDate, filteredSearch, formData);
  }

  getFirstAvailableDate() {
    let datesArray: (string | Date)[] =
      this.state.monthlyAvailabilityData.monthlyresults.map(
        (date) => date.date
      );
    // Filter out the valid dates
    let enabledDates = datesArray
      .map((date) => (typeof date === "string" ? new Date(date) : date)) // Convert strings to Date objects
      .filter((date) => !isNaN((date as Date).getTime())); // Filter out invalid dates

    // Sort the enabled dates in ascending order
    enabledDates.sort((a, b) => (a as Date).getTime() - (b as Date).getTime());

    // Get the first enabled date (first day of the month)
    let firstEnabledDate = enabledDates[0] as Date;
    return firstEnabledDate;
  }
  hideAvailability() {
    let firstEnabledDate = this.getFirstAvailableDate();
    this.props.hideAvailability(firstEnabledDate);

    /**
     * PWAS Analytics when we click on back to search
     * reults on Book your Holiday Page
     */
    console.log("isAlternate", this.props.isAlternateSearchAvailable);
    logAnalyticData(
      {
        event: "Search Resorts",
        siteSection: "",
        pageName: "Book My Holiday",
        website: "",
      },
      {
        errorMessagfe: "",
        notificationType: "",
        errorMessage: "",
        resortID: "",
        typeofSearch: "",
        filtersApplied: "", // TODO: Populate the data
        step: "Points Booking – Step 3 – Back to Search Results",
        alternativeSearchResorts: this.props.isAlternateSearchAvailable
          ? "yes"
          : "no",
      }
    );
    trackAnalyticData("Points Booking – Step 3 – Back to Search Results");
  }

  availabilityDateSelect(day: Date) {
    this.setState({
      selectedDate: day,
      dateForPoints: day,
      startDate: day,
      endDate: day,
      // waitlistOptionsForVillasNotAvailable: false
    });

    /**
     * PWAS Analytics upon selection of
     * date on monthly calendar
     */

    logAnalyticData(
      {
        event: "Select Availability",
        siteSection: "",
        pageName: "Book My Holiday",
        website: "",
      },
      {
        ownerActivity: "",
        step: "Step 3:Select Availability",
        errorMessagfe: "",
        notificationType: "",
        customerID: "",
        searchCheckInDate: "",
        filtersApplied: "",
        typeOfSearch: "",
        alternativeSearchResorts: this.props.isAlternateSearchAvailable
          ? "yes"
          : "no",
      }
    );
    trackAnalyticData("points:step3");
  }

  onCheckInDaySelected(e: any) {
    const dates = this.state.checkInDays;
    let day = dates.find((day) => day.weekName === e.target.name);
    if (day) day.selected = e.target.selected;
    this.setState({
      checkInDays: [...dates],
    });
  }

  getAddtoWaitilistDisabledStatus = () => {
    const dates = this.state.checkInDays;
    let isValid = false;
    dates.forEach((item) => {
      if (item.selected) {
        isValid = true;
      }
    });
    return isValid && this.state.startDate && this.state.endDate;
  };

  handleSpacebar(e: any) {
    if (e.keyCode == 32) {
      let firstAvailableDate = this.getFirstAvailableDate();
      this.props.hideAvailability(firstAvailableDate);
    }
  }

  changePropCode(propCode: string) {
    this.setState({
      propCode: propCode,
    });
  }

  toggleResortModal = (propertyCode: string) => {
    this.setState({
      resortModal: {
        propertyCode,
        show: !this.state.resortModal.show,
      },
    });
  };

  /**
   * Generate a tooltip for a day in the availability calendar
   */
  dayToolTip(minPoints: number): Tip[] {
    return [
      {
        label: "static.content.points-starting",
        desc: minPoints.toString(),
      },
    ];
  }

  getRefreshedMonth() {
    // Array of date objects for the date picker.
    // These dates are considered 'available'.
    let datesArray: (string | Date)[] =
      this.state.monthlyAvailabilityData.monthlyresults.map(
        (date) => date.date
      );
    let monthRefresh: Date | string = new Date(
      datesArray[0] ? datesArray[0] : this.state.startDate
    );
    monthRefresh = moment(monthRefresh).startOf("month").format("MM/DD/YYYY");
    return monthRefresh;
  }
  /**
   * Check if a date is outside the booking window for this resort
   */
  isDateOutsideWindow(date: Date) {
    if (!this.state.monthlyAvailabilityData.maxOutMonth) {
      return false;
    }
    const dateAfterWindow = moment(date).isAfter(
      this.state.monthlyAvailabilityData.maxOutMonth
    );
    const dateBeforeToday = moment(date).isBefore(
      moment().format("MM/DD/YYYY")
    );

    // logAnalyticData({ event: 'Search Resorts', siteSection: '', pageName:'Book My Holiday', website:'' }, {
    //     ownerActivity: '',
    //     step:'Step 3 – Outside-Booking-Window 1',
    //     errorMessagfe:"",
    //     notificationType: "",
    //     benefitLevel:sessionStorage.getItem('BenefitLevel'),
    //     ownerType:sessionStorage.getItem('OWNER_NUMBER'),
    //     customerID:"",
    //     searchCheckInDate: "",
    //   })
    //   trackAnalyticData('Points Booking - Step 3 – Outside-Booking-Window');

    return dateBeforeToday || dateAfterWindow;
  }

  getActiveMonths = () => {
    if (!this.state.monthlyAvailabilityData.maxOutMonth) {
      return this.props.searchMonths;
    }
    const activeMonths = this.props.searchMonths.filter((x) =>
      moment(x.value).isSameOrBefore(
        this.state.monthlyAvailabilityData.maxOutMonth || moment()
      )
    );
    return activeMonths;
  };

  getStartDate = () => {
    return this.props.selectedMonth
      ? this.props.selectedMonth
      : this.props.form.startDate;
  };

  checkValidation(start: any, end: any) {
    var mStartDate = moment(start);
    var mEndDate = moment(end);
    if (mStartDate.isSame(mEndDate)) {
      return false;
    }
    return !mStartDate.isBefore(mEndDate);
  }
  handleInput(e: any): void {
    const target = e.target;
    let value = target.value;
    let name = target.name;
    if (name === "startDate") {
      const startDateValidation = this.state.endDate
        ? this.checkValidation(value, this.state.endDate)
        : false;
      this.setState({
        startDate: value,
        startDateError: startDateValidation,
        endDateError: false,
      });
    } else {
      const startDateValidation = this.state.startDate
        ? this.checkValidation(this.state.startDate, value)
        : false;
      this.setState({
        dateForPoints: new Date(value),
        endDate: value,
        startDateError: false,
        endDateError: startDateValidation,
      });
    }
  }
  getWaitlistOptionsDateLabel = () => {
    if (this.state.selectedDate) {
      return moment(this.state.selectedDate).format("DD MMM YYYY");
    } else {
      if (this.props.form.flexibleSearch)
        return moment(this.props.form.startDate).format("MMM YYYY");
      else return moment(this.props.form.startDate).format("DD MMM YYYY");
    }
  };

  setEditingSegment = (segment: Segment) => {
    this.props.setEditingSegment({
      ...segment,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      checkInDays: this.state.checkInDays,
      selectedDate: this.state.selectedDate,
    });
  };

  onClearSearch = () => {
    this.setState({
      checkInDays: JSON.parse(JSON.stringify(defaultCheckInDays)),
    });
    this.props.onClearSearch();
  };

  render() {
    const { localize } = this.context;
    // Object containing tooltips for each date.
    // Key is date.valueOf() and value is Tip[].
    let dayTooltips: { [index: string]: Tip[] } = {};
    this.state.monthlyAvailabilityData.monthlyresults.forEach((date) => {
      dayTooltips[date.date.valueOf()] = this.dayToolTip(date.minimumPoints);
    });
    let datesArray: (string | Date)[] =
      this.state.monthlyAvailabilityData.monthlyresults.map(
        (date) => date.date
      );

    const accessibilityOption: string =
      this.props.form.accessibility === ""
        ? ""
        : this.props.accessibilityOptions.find((option: any) => {
            return option.value === this.props.form.accessibility;
          }).description;

    //only pass in selectedDate as activeDate to date picker if the last selectedDate and selectedMonth are in the same month/year
    const { selectedMonth } = this.props;
    const { selectedDate } = this.state;
    let selectedDateIn: Date | null = null;
    let isSameMonth = moment(selectedMonth).isSame(
      selectedDate ? selectedDate : "",
      "month"
    );
    let isSameYear = moment(selectedMonth).isSame(
      selectedDate ? selectedDate : "",
      "year"
    );
    if ((isSameMonth && isSameYear) || (!selectedMonth && selectedDate)) {
      selectedDateIn = selectedDate;
    }

    const startDate = this.getStartDate();

    return (
      <div className="row">
        <div className="columns ten results-list">
          {!this.state.hideHeader && (
            <div className="check-availability-header">
              <div className="select-availability">
                {localize("static.content.select-availability")}
              </div>
              <div className="backtosearch-div">
                <button
                  onKeyDown={this.handleSpacebar}
                  className="button-back-to-search"
                  onClick={() => {
                    if (this.props.isAlternateSearchAvailable) {
                      sessionStorage.write("backToSearch", "alternate");
                    } else {
                      sessionStorage.write("backToSearch", "searchResult");
                    }

                    this.props.hideAvailability(this.getFirstAvailableDate());
                  }}
                >
                  <MvIcon
                    height="12px"
                    width="12px"
                    icon="reply"
                    color="black"
                  />
                  {localize("static.content.back-to-search-results")}
                </button>
              </div>
            </div>
          )}

          {!this.state.hideCalendar && (
            <React.Fragment>
              <MvResortModal
                show={this.state.resortModal.show}
                propertyCode={this.state.resortModal.propertyCode}
                toggle={() =>
                  this.setState({
                    resortModal: {
                      ...this.state.resortModal,
                      show: !this.state.resortModal.show,
                    },
                  })
                }
              />
              <div className="ca-single">
                <div className="row ca-single-row">
                  <div className="six columns">
                    <CheckAvailabilityHotelInformation
                      result={this.props.result}
                      form={this.props.form}
                      accessible={accessibilityOption}
                      hearing={true}
                      openModal={this.toggleResortModal}
                      propCode={this.changePropCode}
                      onFilterSelect={this.onFilteredSelect}
                      selectedFilters={this.props.selectedFilters}
                      filters={this.state.monthlyAvailabilityData.filters}
                    />
                  </div>
                  {this.state.loadError &&
                  this.state.errorCode !== "BOOKING_WINDOW_VALIDATION_ERROR" ? (
                    <div className="availability-failure-error">
                      <p>
                        {localize(
                          "static.content.calendar-not-loading-error-label"
                        )}
                      </p>
                      <p>
                        {localize(
                          "static.content.calendar-not-loading-error-message"
                        )}
                      </p>
                    </div>
                  ) : (
                    <div className="calendar-sect">
                      <p className="calendar-top-text">
                        {localize("static.content.select-check-in-date")}
                      </p>
                      <div className="availability-calendar-internal">
                        <DatePicker
                          refreshAvailability={
                            this.fetchMonthlyAvailabilityData
                          }
                          startDate={startDate}
                          onDayClick={this.availabilityDateSelect}
                          data={
                            this.state.monthlyAvailabilityData.monthlyresults
                          }
                          enabledDates={datesArray}
                          searchMonths={this.getActiveMonths()}
                          activeDate={selectedDateIn}
                          dayTooltips={dayTooltips}
                          loader={this.state.loader}
                          isDateOutsideWindow={this.isDateOutsideWindow}
                          hasLoadError={
                            this.state.loadError &&
                            this.state.errorCode ===
                              "BOOKING_WINDOW_VALIDATION_ERROR"
                          }
                        />
                      </div>
                      <div className="text-align-center">
                        <button
                          onClick={() =>
                            this.fetchMonthlyAvailabilityData(
                              this.getRefreshedMonth()
                            )
                          }
                          className={
                            this.state.loader
                              ? "mv-button primary rectangle-refresh disabled"
                              : "mv-button primary rectangle-refresh"
                          }
                        >
                          <span className="refresh-availability">
                            {localize("static.content.refresh-availability")}
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  {/* {selectedDateIn && //This was added back to ensure points for search are only displayed after user selects a day in the calendar
                                        <div>
                                            <PointsForSearch
                                                selectedDate={this.state.dateForPoints as Date}
                                                currentBalance={`${this.state.currentPointsBalance}`}
                                                potentialBalance={`${this.state.potentialPointBalance}`}
                                            />
                                        </div>
                                    } */}
                  {selectedDateIn && (
                    <>
                      {/* { <PointsForSearch
                                                selectedDate={this.state.dateForPoints as Date}
                                                currentBalance={`${this.state.currentPointsBalance}`}
                                                potentialBalance={`${this.state.potentialPointBalance}`}
                                            /> } */}
                      <VillasAvailable
                        hideAvailability={this.props.hideAvailability}
                        onClearSearch={this.onClearSearch}
                        selectedFilters={this.props.selectedFilters}
                        selectedDate={selectedDateIn}
                        availability={[]}
                        monthlyAvailabilityData={
                          this.state.monthlyAvailabilityData
                        }
                        propCode={this.props.result.propertyCode}
                        form={this.props.form}
                        selectedResort={this.props.result}
                        numNights={this.props.form.numNights}
                        numGuest={this.props.form.numNights}
                        goToAYP={this.props.goToAYP}
                        goToWaitlistAYP={this.props.goToWaitlistAYP}
                        getHeldResorts={this.props.getHeldResorts}
                        deleteHeldResorts={this.props.deleteHeldResorts}
                        placeHold={this.props.placeHold}
                        contracts={this.props.contracts}
                        createWaitlist={this.props.createWaitlist}
                        waitlistToggleChecked={true} //{this.state.waitlistOptionsForVillasNotAvailable}
                        loader={this.state.loader}
                        addtoWaitilistDisabledStatus={
                          !this.getAddtoWaitilistDisabledStatus()
                        }
                        setEditingSegment={this.setEditingSegment}
                        editingSegment={
                          this.props.editingSegment
                            ? {
                                form: this.props.editingSegment.form,
                                selectedRooms:
                                  this.props.editingSegment.selectedRooms,
                              }
                            : null
                        }
                        sessionId={this.props.sessionId}
                        checkInDays={this.state.checkInDays}
                        apiTimeout={this.props.apiTimeout}
                      />
                    </>
                  )}
                  {/* Waitlist Option */}
                  {/* { //removing toggle button for now. we will show unavailability always when daily availability checked 
                                        (this.state.monthlyAvailabilityData.monthlyUnavailable || []).length > 0
                                        && this.state.resortWaitlistEligible
                                        && this.state.owner.point >= this.state.minWaitlistRoomtypePoint
                                        && (
                                                <div>
                                                    <MvToggle
                                                        id="waitlistOptionsForVillasNotAvailableToggle"
                                                        labelStyle={{
                                                            color: "#009687",
                                                            fontSize: "12px",
                                                            fontWeight: 600
                                                        }}
                                                        name="waitlistOptionsForVillasNotAvailable"
                                                        label="Waitlist Options for Villas Not Available:"
                                                        checked={this.state.waitlistOptionsForVillasNotAvailable}
                                                        onChange={this.handleWaitlistOptionsForVillasNotAvailable}
                                                    />
                                                </div>
                                            )
                                    } */}
                  <div>
                    {/* commenting out for now. daily check availability will always show unavailablity results for the day selected */}
                    {/* {this.state.waitlistOptionsForVillasNotAvailable && (
                                            <div className="waitlist-options-container">
                                                <div className="waitlist-options-dates">
                                                    <span style={{ display: 'inline-block',paddingRight:"12px" }} >Check-in Date(s):</span>
                                                    <span style={{ display: 'inline-grid', width: '128px' }} className="availability-calendar-internal">
                                                        <MvDatePicker
                                                            id="exact-date"
                                                            name="startDate"
                                                            required={true}
                                                            tabIndex={2}
                                                            softError={"Date not in range"}
                                                            items={this.props.criteria.searchMonths}
                                                            placeholder={localize('static.content.search-by-date')}
                                                            onChange={this.handleInput}
                                                            value={moment(this.state.startDate).format("MM/DD/YYYY")}
                                                        />
                                                        {this.state.startDateError && (<span style={{ color: 'red' }}>Start Date can not be greater than End date</span>)}
                                                    </span> <span style={{ display: 'inline-grid', width: '128px',paddingLeft:"12px" }} className="availability-calendar-internal">
                                                        <MvDatePicker
                                                            id="exact-date"
                                                            name="endDate"
                                                            required={true}
                                                            tabIndex={2}
                                                            softError={"Date not in range"}
                                                            items={this.props.criteria.searchMonths}
                                                            placeholder={localize('static.content.search-by-date')}
                                                            onChange={this.handleInput}
                                                            value={moment(this.state.endDate).format("MM/DD/YYYY")}
                                                        />
                                                        {this.state.endDateError && (<span style={{ color: 'red' }}>End Date can not be less than Start date</span>)}
                                                    </span>
                                                </div>
                                                <div className="waitlist-check-in-days">
                                                    <span>Check-in Day(s): </span>
                                                    <div className="waitlist-check-in-days-buttons">
                                                        {(this.state.checkInDays).map((day, i) => {
                                                            return (
                                                                //return MvButtonToggle - onChange property will be assigned to onCheckInDaySelected
                                                                <MvButtonToggle
                                                                    name={day.weekName}
                                                                    selected={day.selected}
                                                                    label={day.weekName}
                                                                    onChange={this.onCheckInDaySelected}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        )} */}
                    {/* I think this needs to check for unavailablityresults in daily check availability response */}
                    {/* {selectedDateIn && //this.state.waitlistOptionsForVillasNotAvailable && 
                                            <VillasNotAvailable
                                                rangeStartDate={moment(this.state.startDate).format("YYYY-MM-DD")}
                                                rangeEndDate={moment(this.state.endDate).format("YYYY-MM-DD")}
                                                addtoWaitilistDisabledStatus={!this.getAddtoWaitilistDisabledStatus()}
                                                hideAvailability={this.props.hideAvailability}
                                                onClearSearch={this.onClearSearch}
                                                selectedFilters={this.props.selectedFilters}
                                                selectedDate={moment(this.state.startDate).toDate()}
                                                availability={[]}
                                                propCode={this.props.result.propertyCode}
                                                form={this.props.form}
                                                selectedResort={this.props.result}
                                                numNights={this.props.form.numNights}
                                                numGuest={this.props.form.numNights}
                                                goToAYP={this.props.goToAYP}
                                                goToWaitlistAYP={this.props.goToWaitlistAYP}
                                                getHeldResorts={this.props.getHeldResorts}
                                                deleteHeldResorts={this.props.deleteHeldResorts}
                                                placeHold={this.props.placeHold}
                                                createWaitlist={this.props.createWaitlist}
                                                waitlistToggleChecked={true}//always true or only if unavailableresults? {this.state.waitlistOptionsForVillasNotAvailable}
                                                setEditingSegment={this.setEditingSegment}
                                                editingSegment={
                                                    this.props.editingSegment ?
                                                    {
                                                        form: this.props.editingSegment.form,
                                                        selectedRooms: this.props.editingSegment.selectedRooms,
                                                    } : null
                                                }
                                                sessionId={this.props.sessionId}
                                                checkInDays={this.state.checkInDays}
                                            />
                                        } */}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {this.state.buttonClicked && this.state.hideCalendar && (
            <ConfirmAvailability
              roomSelected={this.props.result}
              selectedDate={this.props.form.startDate}
              numOfNights={this.props.form.numNights}
              numGuest={this.props.form.numGuests}
            />
          )}
        </div>
        <FilterResults
          checkAvailabilty={true}
          isMobileFilterOpen={this.props.isMobileFilterOpen}
          toggleMobileFilter={this.props.toggleMobileFilter}
          filters={this.state.monthlyAvailabilityData.filters}
          selectedFilters={this.props.selectedFilters}
          onSelect={this.onFilteredSelect}
          onClear={this.onFilterClear}
          toggleOpen={this.props.toggleFilterGroup}
          disableActivitiesFilter={true}
          disableAreaFilter={true}
          disableViewFilter={false}
          disableClearFilter={false}
          disableRoomTypeFilter={false}
        />
      </div>
    );
  }
}

CheckAvailabilityResultItem.contextType = LocalizationContext;

export default CheckAvailabilityResultItem;
